<!-- 通用组件 - 定制操作框 -->
<!-- 调用方式
    <action-modal @handleFunc="execFunc"
                  :msg="modalInfo.msg"
                  :isShown="modalInfo.isShown"
                  :buttons="modalInfo.buttons"
    ></action-modal>
-->
<!-- 父组件传值
   modalInfo:{
          msg: String，窗口显示内容，不可空,
          isShown: Boolean，可空，是否显示窗口，默认为false,
          buttons: 数组，可空，默认一个按钮（最多只能传两组数据）。默认按钮描述为‘确定’，点击关闭窗口
          [
            {
              desc: 'test',   String，按钮描述文字
              func: 'test',   String，父组件的回调方法名
            }
          ]
        }
-->
<!-- 父组件必须在methods中有一个execFunc方法，该方法接收一个字符串，为需要调用的父组件的方法名
   execFunc(func){
        if(this[func] && typeof this[func] == 'function'){
          this[func]();
        }else{
          console.log(func + ' is not valid function');
        }
      }
-->
<template>
  <transition name="fade" v-if="isShown">
    <div class="modal-box">
      <div class="context" @click="btnEmit('closeModal')">1</div>
      <div class="modal">
        <div class="modal-title clearfix">
          <span class="title" v-text="title"></span>
          <span class="modal-close" @click="btnEmit('closeModal')">x</span>
        </div>
        <div class="modal-content" v-text="msg"></div>
        <div class="modal-btn">
          <div class="modal-btn-container" :style="{width: 230*buttons.length + 'px'}">
            <a href="javascript:;" v-for="button in buttons" v-text="button.desc" @click="btnEmit(button.func)"></a>
          </div>
          <!--<a href="javascript:void(0);" v-text="modalInfo.rightBtn.desc" @click="modalInfo.rightBtnEmit"></a>-->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'actionModal',
    data () {
      return {
        title: '消息提示',
      }
    },
    mounted () {

    },
    props:{
      msg: {  //窗口内容
        type: String,
        default: ''
      },
      isShown: {  //控制窗口是否显示
        type: Boolean,
        default: false
      },

      //按钮定义，默认存在，如果用户不传值，则有一个确认按钮，事件默认为关闭弹窗
      //desc: 按钮文字；func: 执行的回调函数；
      buttons: {
        type: Array,
        default: function(){
            return [
              {
                desc: '确认',
                func: 'closeModal',
              }
            ]
        }
      }
    },
    methods: {
      //关闭弹窗
      closeModal () {
          this.isShown = false;
//        this.$store.commit('showMsgModal', false);
      },
      //关闭窗口，并触发父层的相应函数
      btnEmit(func){
        if(!func){
          console.log('no event bind to button');
          return;
        }
        if(func != 'closeModal'){
          this.$emit('handleFunc', func);
        }
//        this.closeModal();
        //关闭状态需要传给父组件
        this.$emit('handleFunc', 'hideModal');

      },
    }
//    computed: {
//      getModalState () {
//        return this.$store.state.msgModal.showMsgModal
//      },
//      getModalMsg () {
//        return this.$store.state.msgModal.msg
//      }
//    }
  }

</script>

<style scoped>
  /*clearfix Start*/
  .clearfix:after{
    content:".";
    display:block;
    height:0;
    clear:both;
    visibility:hidden
  }
  .clearfix{
    *+height:1%;
  }

  /*transition Start*/
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-active {
    /*transition: 1s;*/
    opacity: 0;
  }
  /*transition End*/

  /*Modal Start*/
  .modal-box,
  .context
  {
    width:100%;
    height:100%;
    position: fixed;
    left:0;
    top:0;
  }
  .context{
    background-color: #333;
    opacity:0.8;
  }
  .modal{
    width:640px;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    height:330px;
    background-color: #ffffff;
    border-radius: 7px;
    border:solid 1px #Eb828c;
    padding-left:18px;
    padding-right:18px;
  }
  .modal-title{
    height:50px;
    line-height: 50px;
    border-bottom:solid 1px #d2d2d2;
  }
  .title,
  .modal-close{
    color: #b11828;
    font-weight: 700;
  }
  .title{
    float: left;
  }
  .modal-close{
    float: right;
    cursor:pointer;
  }
  .modal-content{
    width:320px;
    margin:0 auto;
    color:#000;
    font-size:16px;
    min-height:30px;
    line-height: 30px;
    height:100px;
    padding:20px 20px 20px;
    text-align: center;
  }
  .modal-btn{
    width: 100%;
    margin-top: 30px;
    border-bottom: solid 1px #ccc;
    padding-bottom: 20px;
  }
  .modal-btn > .modal-btn-container{
    /*display: block;*/
    /*width: 460px;*/
    margin: 0 auto;
    /*left: 50%;*/
    height: 50px;
    line-height: 50px;
    text-align: center;
    text-decoration: none;
    border-radius: 5px;
  }

  .modal-btn a{
    display: inline-block;
    text-align: center;
    float: left;
    width: 200px;
    margin-right: 30px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    background-color: #b11828;
    text-decoration: none;
    border-radius: 5px;
  }
  /*Modal End*/
</style>



// WEBPACK FOOTER //
// ActionModal.vue?289a89eb